import api from "../../services/api";

/* import api from "../../services/api";
 */
const namespaced = true;

const state = {
    selectedDateRange: [],
    selectedEventsIDs: [],
    availableEvents: [],
    selectedSensors: [],
    singleDeflectionDate: new Date()
};

const getters = {
    getDateRange: (state) => state.selectedDateRange,
    getSelectedEvents: (state) => state.selectedEventsIDs,
    getSelectedSensors: (state) => state.selectedSensors
};

const actions = {
    async setDateRange ({ commit }, dateRange) {
        commit("selectDateRange", dateRange)
    },
    async setSingleDeflectionDate({commit}, date){
        commit("setSingleDeflectionDate", date)
    },
    async setSelectedEvents ({ commit }, events) {
        commit("selectEvents", events)
    },
    async setSelectedSensors ({ commit }, sensors) {
        commit("selectSensors", sensors)
    },
    async fetchEvents ({ commit }) {
        let totalEventsPromises = state.selectedSensors.map(sensor => api.getTiltsList(sensor.eui, state.singleDeflectionDate, state.singleDeflectionDate, false, sensor.beamFormat))
        let totalTilts = await Promise.all(totalEventsPromises)
        commit("setEvents", totalTilts)
    }
};

const mutations = {
    selectDateRange: (state, range) => (state.selectDateRange = range),
    selectEvents: (state, IDs) => (state.selectedEventsIDs = IDs),
    selectSensors: (state, sensors) => (state.selectedSensors = sensors),
    setEvents: (state, events) => (state.availableEvents = events),
    setSingleDeflectionDate: (state, date) => (state.singleDeflectionDate = date)
};

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
